export const isInvisible = 'owc-is-invisible';
export const hasNoHeight = 'owc-has-no-height';
